import DataDownload from '../DataDownload';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import CancelButton from '../CancelButton';
import { globalStyles as styles } from '../style/gstheme';

class VersionDownloadDialog extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            open: false,
        };
        this.cancellable = null;
    }

    render() {

        const { classes, id, graph, onExitDownload, open, exportName, title } = this.props;

        return (
            <Dialog
                data-test="version-download-dialog"
                classes={{
                    paper: classes.paper
                }}
                className={classes.dialog}
                open={open}
                aria-labelledby="version-download-dialog-title">
                <DialogTitle disableTypography className={classes.mainHeading} id="version-download-dialog-title">Download Version</DialogTitle>
                <DialogContent>
                    <DataDownload
                        title={title}
                        graph={graph}
                        resource={id}
                        exportName={exportName}
                        includeXL={true}
                        hideXLoption={true}
                        message="Includes data for all components in this version." />
                </DialogContent>
                <DialogActions className={classes.dialogActions}>
                    <CancelButton onClick={onExitDownload}>Close</CancelButton>
                </DialogActions>
            </Dialog>
        );
    }
}

VersionDownloadDialog.defaultProps = {
    open: false
};

VersionDownloadDialog.propTypes = {
    classes: PropTypes.object,
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    graph: PropTypes.string.isRequired,
    exportName: PropTypes.string.isRequired,
    onExitDownload: PropTypes.func.isRequired,
    open: PropTypes.bool
};

export default withStyles(styles)(VersionDownloadDialog);